// extracted by mini-css-extract-plugin
module.exports = {"siteLogo":"siteLogo-module--siteLogo--3eDwY"};